<template>
  <div>
    <v-alert type="info" v-if="divivaAnoPassado">Estudante com dividas do ano passado!</v-alert>

    <!-- ===== INÍCIO DA TABELA ==== -->
    <div class="main_table_container">
      <table class="table-full">
        <thead class="bg-gray100">
          <tr>
            <th class="table_head">#</th>
            <th class="table_head">Emol.</th>
            <th class="table_head">Ref.</th>
            <th class="table_head">Ano</th>
            <th class="table_head">Qtd.</th>
            <th class="table_head">P. Uni.</th>
            <th class="table_head">Multa</th>
            <th class="table_head">Desc.</th>
            <th class="table_head">Trimestre</th>
            <th class="table_head">Subtotal</th>
            <th class="table_head">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(emolumento, index) in desserts" :key="index">
            <td class="table_data">{{ ++index }}</td>
            <td class="table_data">
              <span class="color-table-data">{{ emolumento.emolumento }}</span>
            </td>
            <td class="table_data">
              <span>{{
                utilitarios.getMonthDescription(emolumento.fkMes)
              }}</span>
            </td>
            <td class="table_data">
              <span>{{ emolumento.anolectivo }}</span>
            </td>
            <td class="table_data">
              <span>{{ emolumento.qtd }}</span>
            </td>
            <td class="table_data">
              <span>{{
                utilitarios.IntegerToMoneyValueFatura(emolumento.preco)
              }}</span>
            </td>
            <td class="table_data">
              <span>{{
                utilitarios.IntegerToMoneyValueFatura(emolumento.valorMulta)
              }}</span>
            </td>
            <td class="table_data">
              <input style="
                  background-color: #fff;
                  border: 1px solid #e2e8f0;
                  width: 100%;
                  padding: 2px;
                  text-align: center;
                " v-if="emolumento.isSelected" @change="moneyFormat(emolumento)"
                :disabled="!desserts[desserts.indexOf(emolumento)].isSelected"
                v-model="desserts[desserts.indexOf(emolumento)].desconto" />
              <span v-if="!emolumento.isSelected">{{
                isNaN(emolumento.desconto) || !emolumento.desconto
                  ? ""
                  : utilitarios.IntegerToMoneyValueFatura(emolumento.desconto)
              }}</span>
            </td>
            <td class="table_data">
              <span>{{
                emolumento.trimestre == 0 ? "N/A" : emolumento.trimestre + "º"
              }}</span>
            </td>
            <td class="table_data">
              <span>{{
                utilitarios.IntegerToMoneyValueFatura(emolumento.subtotal)
              }}</span>
            </td>
            <td class="table_data">
              <span>
                <v-btn small fab color="#4b5747" v-if="emolumento.cobrar">
                  <input class="form-check-input" @change="uncheckFunction(emolumento)" type="checkbox"
                    v-model="desserts[desserts.indexOf(emolumento)].isSelected" id="flexCheckChecked" />
                </v-btn>
                <v-tooltip left v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab color="warning" style="color: white; margin-top: 5px" small>
                      <v-icon>info</v-icon>
                    </v-btn>
                  </template>
                  <span> Mês inseto de cobrança! </span>
                </v-tooltip>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- ===== FIM DA TABELA ==== -->

    <!--==== CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
    <div class="totaisContainer">
      <div>
        <span class="align-totais">A cobrar:</span>
        <span class="text-bold totais-font-size">{{
          utilitarios.IntegerToMoneyValueFatura(totaisObject.total)
        }}</span>
      </div>
      <div>
        <span class="align-totais">Valor de multa:</span>
        <span class="text-bold totais-font-size">{{
          utilitarios.IntegerToMoneyValueFatura(totaisObject.multa)
        }}</span>
      </div>
      <div>
        <span class="align-totais">Descontos:</span>
        <span v-if="!isNaN(totaisObject.desconto)" class="text-bold totais-font-size">
          {{ utilitarios.IntegerToMoneyValueFatura(totaisObject.desconto) }}
        </span>
      </div>
      <div>
        <span class="align-totais">Total a pagar:</span>
        <span v-if="!isNaN(totaisObject.totalGeral)" class="text-bold totais-font-size">
          {{ utilitarios.IntegerToMoneyValueFatura(totaisObject.totalGeral) }}
        </span>
      </div>
    </div>
    <!--====  FIM CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->

    <!--====== BOTÃO FINALIZAR PAGAMENTO =======-->
    <v-row style="padding-bottom: 15px">
      <div class="botoesAccaoContainer">


         <!-- <v-tooltip bottom v-if="isAtLeastOneEmolumentoSelected && !isError">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="continuarImprimirProforma()" color="primary">
              <v-icon>print</v-icon> Imprimir Factura Proforma
            </v-btn>
          </template>
          <span> Clique neste botão para imprimir a factura proforma</span>
        </v-tooltip> -->


        <v-tooltip bottom v-if="isAtLeastOneEmolumentoSelected && !isError">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" @click="continuarPagamento()" color="success">
              <v-icon>done</v-icon> Continuar Pagamento
            </v-btn>
          </template>
          <span> Continuar o processo de pagamento</span>
        </v-tooltip>
      </div>
    </v-row>
    <!--====== FIM BOTÃO FINALIZAR PAGAMENTO =======-->
  </div>
</template>

<script>
import utilitarios from "../../plugins/utilitarios";
import axios from "../../plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");

export default {
  data() {
    return {
      utilitarios: utilitarios,
      isError: false,
      divivaAnoPassado: false,
      desserts: [],
      dessertsPassados: [],
      trimestreSeleted: {
        id: 0,
        descricao: "Todos",
      },
      dataPagamentoSelected: null,
      emolumentos: [],
      bolseiro: null
    };
  },

  props: {
    estudante: Object,
    dataPagamento: undefined,
    trimestre: {
      type: Object,
      default: null,
    },
    anoLectivoEscolhido: []
  },

  watch: {
  anoLectivoEscolhido: {
    immediate: true,
    handler() {
      this.PesquisarStatusPagamento();
    }
  },
  dataPagamento: {
    immediate: true,
    handler(newVal) {
      this.dataPagamentoSelected = newVal;
    },
  },
  trimestre: {
    immediate: true,
    handler(newVal) {
      if (newVal) {
        this.trimestreSeleted = newVal;
      }
    },
  },
},


  async created() {
    await this.vericarBolseiro();
    await this.PesquisarStatusPagamento();    
  },

  computed: {
    anolectivo() {
      return ls.get("anolectivo");
    },

    nomeUsuario (){
      return ls.get('nomeUsuario')
    },

    totaisObject() {
      let totais = { multa: 0, desconto: 0, total: 0, totalGeral: 0,totalIva:0 };
      this.desserts.forEach((element) => {
        if (element.isSelected) {
          
          totais.totalIva += (element.iva === null || element.iva === undefined)?0: element.iva          
          totais.multa += element.valorMulta === "N/A" ? 0 : element.valorMulta;
          totais.desconto +=
            element.desconto === "N/A" ||
              element.desconto === null ||
              element.desconto === undefined
              ? 0
              : utilitarios.MoneyValueToInteger(element.desconto);
          totais.total +=
            element.preco === "N/A"
              ? 0
              : element.fkMes === 100
                ? element.preco * element.qtd
                : element.preco;
          totais.totalGeral += element.subtotal;
        }
      });
      return totais;
    },

    isAtLeastOneEmolumentoSelected() {
      let selectedCounter = 0;
      this.desserts.forEach((element) => {
        if (element.isSelected) {
          selectedCounter += 1;
        }
      });
      return selectedCounter > 0;
    },
  },

  mounted() {
    this.$on("carregarPagamentos", this.PesquisarStatusPagamento);
    this.$on("carregarPagamentoData", this.PesquisarStatusPagamentoData);
    this.$on(
      "carregarPagamentoTrimestre",
      this.PesquisarStatusPagamentoTrimestre
    );
  },

  methods: {
    PesquisarStatusPagamentoData(data) {
      this.dataPagamentoSelected = data;
      this.PesquisarStatusPagamento();
    },

    PesquisarStatusPagamentoTrimestre(trimestre) {
      this.trimestreSeleted = trimestre;
      this.PesquisarStatusPagamento();
    },

    async vericarBolseiro() {
      try {
        let bolseiros = await axios.get("/vericarStatusBolseiro/" + this.estudante.numero_matricula)
          .then((res) => res.data);
        if (bolseiros.length) {
          this.bolseiro = bolseiros[0];
        }
      } catch (error) {
        Swal.fire("Erro", "Erro ao verificar bolseiro!", "error"
        );
      }
    },

    async PesquisarStatusPagamento() {
      
      this.isLoading = true;
      try {
        let payload = {
          result: this.estudante,
          semestreId: this.trimestreSeleted.id,
          dataPagamento: this.dataPagamentoSelected,
          anoLectivoEscolhido: this.anoLectivoEscolhido.anolectivo
        };
        

        let result = await axios.post("/ObterMensalidadesPorPagar", payload).then((res) => res.data);         
        
        if (result.length) {
          if (this.bolseiro) {
            result.forEach((element) => {
              const isMultaTipo1 = this.bolseiro.tipoMulta == 1;
              const isMultaTipo2Emolumento15 = this.bolseiro.tipoMulta == 2 && element.idEmolumento == 15;
              const isMultaTipo5NotEmolumento15 = this.bolseiro.tipoMulta == 5 && element.idEmolumento != 15;

              if (isMultaTipo1 || isMultaTipo2Emolumento15 || isMultaTipo5NotEmolumento15) {
                element.valorMulta = 0;
              }

              const isEmolumento15 = element.idEmolumento == 15;

              if (isEmolumento15) {
                element.valorMulta == 0 ? element.subtotal = element.preco : element.subtotal = element.subtotal
                element.subtotal = this.bolseiro.isPercentagem == 1
                  ? this.calcularPercentagem(this.bolseiro.valor_desconto, element.subtotal)
                  : element.subtotal - this.bolseiro.valor_desconto;
              }
            });
          }

          this.dessertsPassados = result.filter((d) => d.anolectivo < this.anolectivo);
          if (this.dessertsPassados.length) {
            this.divivaAnoPassado = true;
            setTimeout(() => {
              this.divivaAnoPassado = false;
            }, 3000)
          }

          this.desserts = result.filter((e) => e.anolectivo == this.anoLectivoEscolhido.novadescricao);
        }
      } catch (error) {  
        console.log(error);
        
        
        Swal.fire(
          "Informação",
          "Erro ao carregar as mensalidades do estudante",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    calcularPercentagem(parte, total) {
      return total - ((parte / 100) * total);
    },

    moneyFormat(produto) {
      try {
        this.isError = false;
        if (
          produto.desconto < 0 ||
          produto.desconto.trim() == "" ||
          isNaN(produto.desconto.trim())
        ) {
          produto.desconto = "0";
        }
        let subTotal = produto.preco + produto.valorMulta - this.utilitarios.MoneyValueToIntegerWithouKz(produto.desconto);          
        if (subTotal < 0) {
          Swal.fire(
            "Informação",
            "O valor do desconto não pode ser maior do que o preço a pagar",
            "warning"
          );
          this.isError = true;
        }

        this.desserts[this.desserts.indexOf(produto)].desconto = this.utilitarios.IntegerToMoneyValueFatura(produto.desconto);
        this.desserts[this.desserts.indexOf(produto)].descontoInteiro = this.utilitarios.MoneyValueToIntegerWithouKz(produto.desconto);
        this.desserts[this.desserts.indexOf(produto)].subtotal = subTotal;
      } catch (error) {
        Swal.fire("Informação", "Erro ao fazer o desconto!", "error");
      }
    },

    async uncheckFunction(produto) {
      let subTotal = produto.subtotal + this.utilitarios.MoneyValueToIntegerWithouKz(produto.desconto);
      this.desserts[this.desserts.indexOf(produto)].subtotal =  subTotal
      this.desserts[this.desserts.indexOf(produto)].desconto = "";
      if (produto.fkMes === 1000 && produto.isSelected === false) {
        let params = {
          item: produto.pkItemsVenda,
          emolumento: produto,
          estudante: this.estudante,
        };
        let deleted = await axios
          .post("/deletarItemUnchecked", params)
          .then((res) => res.data);
        if (deleted.affectedRows >= 1) {
          this.PesquisarStatusPagamento();
        }
      }
    },

    async continuarImprimirProforma () {
      let paramsVenda = {
        venda: this.desserts.filter(
          (i) => i.isSelected === true || i.isSelected === 1
        ),
        autor: this.nomeUsuario,
        clienteDados: this.estudante,
        totais: this.totaisObject,
      };

      let params = {
            documento: "",
            tipoDocumento: null,
            cliente: this.estudante,
            nif: "",
            formaPagamento: 6,
            venda: paramsVenda.venda,
            valorIliquido: this.totaisObject.total,
            valorApagar: this.totaisObject.totalGeral,
            valorPago: this.totaisObject,
            troco:  0,
            totalMulta: this.totaisObject.multa,
            iva: 0,
            desconto: 0,
            pkCaixa: ls.get("pkCaixa"),
            fkEntidade: null,
            recibo: null,
            recibos: [],
            ContasBancariasPk: [],
            tpa: null,//this.tpa[0].id,
            tpaRef: null,//this.tpa[0].descricao,
            formaPagamentoDescricao: null,//this.tpa[0].descricao,
            tpa2: null,//this.multiplasFormas ? this.tpa[1].id : null,
            tpaRef2: null,// this.multiplasFormas ? this.tpa[1].descricao : "",
            formaPagamentoDescricao2: null,// this.multiplasFormas
             // ? this.tpa[1].descricao
             // : "",
            //  pagamento1: this.pagamento1,
            //  pagamento2: this.pagamento2,
            ficheiros: null,//this.arrayFicheiros,
            guid: null,// uuidv4(),
            autor: ls.get("nomeUsuario"),
            clienteDados: this.estudante,
            identificadorComprovativo: null, //this.identificadorComprovativo,
            identificadorComprovativo2: null,//this.identificadorComprovativo2,
            dataPagamentoSelected: utilitarios.ObterDataActural(),
            dataPagamentoLinha: utilitarios.ObterDataActural(),
          };          

          let htmlContent = `
            <p style="text-align: center;"><strong style="color: red;">OBS:</strong> Confirme os dados da proforma.</p>
            <div style="width: 90%; margin: 10 auto;">
              <div style="display: grid; grid-template-columns: 150px auto;">
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.cliente.nome}</div>
                 `;

           
          htmlContent += `
          <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Data:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${
                  params.dataPagamentoSelected
                }</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Total da factura:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(
                  params.valorIliquido
                )}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Valor pago:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(
                  '0'
                )}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Desconto:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${
                  params.desconto
                    ? this.utilitarios.IntegerToMoneyValue(params.desconto)
                    : this.utilitarios.IntegerToMoneyValue(0)
                }</div>
               
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Multa:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(
                  params.totalMulta
                )}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Total a pagar:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.utilitarios.IntegerToMoneyValue(
                  params.valorApagar
                )}</div>
              </div>
            </div>
          `;

          Swal.fire({
            title: "Gerar a factura",
            html: htmlContent,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Gerar Proforma",
            reverseButtons: true,
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              try {
                let result = await axios.post('FinalizarProcessamentoFacturaProforma',paramsVenda).then((res)=>res.data)
                if (result.affectedRows >= 1) {
                  this.$router.push('faturas-proformas')
                  this.$store.state.from  = 'pagamento'
                }
              } catch (error) {
                if (error.toString().includes("406")) {
                  Swal.fire(
                    "Informação",
                    "O mês ou intervalo de meses selecionado é inválido.",
                    "warning"
                  );
                } else {
                  Swal.fire(
                    "Informação",
                    "Erro ao efectuar a operação!",
                    "error"
                  );
                }
              }
            }
          });
 
    },

    continuarPagamento() {
      let paramsVenda = {
        venda: this.desserts.filter(
          (i) => i.isSelected === true || i.isSelected === 1
        ),
        totais: this.totaisObject,
      };
      this.$emit("continuarPagamento", paramsVenda);
    }
  },
};
</script>

<style scoped>
.table-full {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  text-align: center;
}

.bg-gray100 {
  background-color: #f3f4f6;
}

.table_head {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.70rem;
  width: 100%;
  margin: o auto;
}

.table_data {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  border: 1px solid #e2e8f0;
  font-size: 0.70rem;
}

.color-table-data {
  color: #141414;
}

.totaisContainer {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 10px;
}

.align-totais {
  margin-left: 15px;
}

.text-bold {
  font-weight: bold;
}

.totais-font-size {
  font-size: 17px;
}

.botoesAccaoContainer {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 5px 15px;
}

.tpaCombox {
  width: 230px;
  margin: 10px 0;
}
</style>
